import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { Exception } from "sass";

export class AccountantSheetVM extends InterActive{
    private inputData:{value:string , direction:string , notes:string , img:File|null} = { value:'' , direction :'outgoing' , notes:'' , img:null}
    private data:{id:string , value:string , direction:string, img:string , user:{id:string , name:string} , notes:string , created_at:string}[] = [] 
    private total:number = 0
    private income:number = 0
    private outgoing:number = 0
    private from:string = ''
    private to:string = ''
    private finished :boolean = false
    private refresh:boolean = false

    private clearImg:()=>void = ()=>{};
    public get ClearImg():()=>void{ return this.clearImg  }
    public set ClearImg(value:()=>void){ this.clearImg = value ; this.update()  }

    private search:string = '';
    public get Search():string{ return this.search  }
    public set Search(value:string){ this.search = value ; this.update()  }
    
    private type:string = '';
    public get Type():string{ return this.type  }
    public set Type(value:string){ this.type = value ; this.update()  }

    private users:{id:string,name:string}[]  = [];
    public get Users():{id:string,name:string}[] { return this.users  }
    public set Users(value:{id:string,name:string}[] ){ this.users = value ; this.update()  }

    private selectedUser:string = '';
    public get SelectedUser():string{ return this.selectedUser  }
    public set SelectedUser(value:string){ this.selectedUser = value ; this.update()  }

    public get InputData():{value:string , direction:string , notes:string, img:File|null} { return this.inputData }
    public get Data():{id:string , value:string , direction:string, img:string , notes:string  , created_at:string, user:{id:string , name:string}}[]{ return this.data }
    public get From():string{ return this.from }
    public get To():string { return this.to }
    public get Income():number { return this.income }
    public get OutGoing():number { return this.outgoing }
    public get Total():number { return this.total }
    public get Refresh():boolean{ return this.refresh }

    public set Value(value:string) { this.inputData.value = GeneralMethods.removeNonPositiveFloatNumeric(value); this.update() }
    public set Direction(value:string) { this.inputData.direction = value; this.update() }
    public set Notes(value:string){ this.inputData.notes = value; this.update() }
    public set Img(value:File|null){ this.inputData.img = value; this.update() }
    public set From(value:string){ this.from = value; this.update() }
    public set To(value:string ){ this.to = value; this.update() }

    public getUsers(){
        this.loading(async()=>{
            try{
                const response = await ApiRequest.getAdmins()
                if(response){
                    if(response.status=== HttpStatusCode.Ok){
                        if(response.data.status){
                            this.users = response.data.data
                            this.update()
                        }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                    }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }catch { Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
        })
    }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAccountantRecords({})
                    if(response){
                        if(response.status=== HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = [...response.data.data.items]
                                this.total = response.data.data.total
                                this.income = response.data.data.income
                                this.outgoing = response.data.data.outgoing
                                this.refresh = false
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch {   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }

    public searchData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAccountantRecords({from:this.from , to:this.to , search:this.search , type:this.type , user_id:this.selectedUser })
                    if(response){
                        if(response.status=== HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = [...response.data.data.items]
                                this.total = response.data.data.total
                                this.income = response.data.data.income
                                this.outgoing = response.data.data.outgoing
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch {   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }

    public async addData(){
        if(!this.finished){
            try{
                const response = await ApiRequest.getAccountantRecords({from:this.from , to:this.to , id:this.data.length>0?this.data[this.data.length-1].id:undefined , search:this.search , type:this.type , user_id:this.selectedUser })
                if(response){
                    if(response.status=== HttpStatusCode.Ok){
                        if(response.data.status){
                            if(response.data.data.items.length === 0)
                            {
                                this.finished = true
                                this.update()
                            }else {
                                this.data = [...this.data,...response.data.data.items]
                                this.total = response.data.data.total
                                this.income = response.data.data.income
                                this.outgoing = response.data.data.outgoing
                                this.update()
                            }
                        }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                    }else   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }catch(e) { Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
        }
    }

    public send(){
        if(this.inputData.value.length == 0) Notify({type:'danger' , title:'فشل العملية' , body:'برجاء ادخال القيمة'})
        else {
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.addAccountantRecord(this.toFormData())
                        if(response){
                            if(response.status=== HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.inputData = { value:'' , direction :'outgoing' , notes:'' , img:null}
                                    this.clearImg()
                                    this.refresh = true
                                    this.update()
                                }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                            }else   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                        }
                    }catch {   Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
                }
            )
        }
    }

    private toFormData():FormData{
        const formData = new FormData()

        formData.append('value' , this.inputData.value)
        formData.append('direction' , this.inputData.direction)
        formData.append('notes' , this.inputData.notes)
        if(this.inputData.img)formData.append('img' , this.inputData.img)

        return formData
    }

}